import { useCallback, useMemo } from 'react';
import { filterStateToValue, filterValueToState } from '../../lib/filtering/clauseBuilders';
import type { FilterConfig } from '../../lib/filtering/filterConfig';
import type { DataFilters } from '../useDataFilters';

// gloss
export type FilterBinding = {
  values: Record<string, unknown>;
  onValueChange: (key: string, uiValue: unknown) => void;
};

// gloss
export const useFilterBinding = (configs: FilterConfig[], df: DataFilters): FilterBinding => {
  const values = useMemo(
    () => Object.fromEntries(configs.map((config) => [config.key, filterStateToValue(config, df.filters[config.key])])),
    [configs, df.filters],
  );

  const configsByKey = useMemo(() => new Map(configs.map((config) => [config.key, config])), [configs]);

  const onValueChange = useCallback(
    (key: string, uiValue: unknown) => {
      const config = configsByKey.get(key);
      df.setFilter(key, config ? (filterValueToState(config, uiValue) ?? null) : null);
    },
    [configsByKey, df],
  );

  return { values, onValueChange };
};
